import React, { useEffect, useState } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { Label } from 'office-ui-fabric-react';
import { TagPicker } from 'office-ui-fabric-react/lib/Pickers';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';

export const SourceReferencePicker = ({
  onChange,
  label,
}) => {
  const [sourceReferences, setSourceReferences] = useState([]);
  const [loading, setLoading] = useState([true]);
  const [foundListSize, setFoundListSize] = useState(0);
  const [displayedListSize, setDisplayedListSize] = useState(0);

  const getOptions = async () => {
    const { data: sourceReferences } = await axios.get('/api/filer/accounting/lists/sourceReferenceOptions');
    const orderedSourceReferences = [
      ...sourceReferences
        .map(sourceReference => sourceReference.sourceReference)
        .filter(sourceReference => Boolean(sourceReference))
        .sort((a, b) => a.localeCompare(b))
        .map(sourceReference => ({
          key: sourceReference,
          name: sourceReference,
        })),
    ];
    setSourceReferences(orderedSourceReferences);
    setLoading(false);
  };

  useEffect(() => {
    getOptions();
  }, []);

  if (loading) {
    return <Spinner size={SpinnerSize.medium} />;
  }

  const filterSuggestedTags = (filterText) => {
    const filteredList = sourceReferences.filter(tag => tag.name.toLowerCase().indexOf(filterText.toLowerCase()) !== -1);
    const displayedList = filteredList.slice(0, 100);
    setFoundListSize(filteredList.length);
    setDisplayedListSize(displayedList.length);
    return filteredList;
  };

  const pickerSuggestionsProps = {
    suggestionsHeaderText: `Select (Showing ${displayedListSize} of ${foundListSize})`,
    noResultsFoundText: 'No source codes found',
  };

  const elementClicked = () => {
    return filterSuggestedTags('');
  };

  const doOnChange = (selectedList) => {
    const sourceReference = selectedList.length ? selectedList[0].name : '';
    onChange(null, sourceReference);
  };

  const getTextFromItem = (item) => item.name;
  return (
    <div>
      <Label>{label}</Label>
      <TagPicker
        onResolveSuggestions={filterSuggestedTags}
        getTextFromItem={getTextFromItem}
        pickerSuggestionsProps={pickerSuggestionsProps}
        itemLimit={1}
        onEmptyInputFocus={elementClicked}
        onChange={doOnChange}
      />
    </div>
  );
};

SourceReferencePicker.propTypes = {
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
};

export default SourceReferencePicker;
